'use client'

import { AdLeaderboard, AdMidBanner } from '@/components/common/Ad'
import { Splash } from '@/components/common/Splash'
import { CARDART } from '@/defs/misc'

import styles from './HomeTop.module.scss'
import { HomeTopArticles } from './HomeTopArticles/HomeTopArticles'
import { HomeTopCallout } from './HomeTopCallout/HomeTopCallout'
import { HomeTopSidebar } from './HomeTopSidebar/HomeTopSidebar'

export const HomeTop = () => (
  <section className={styles.container}>
    <h1 className='visually-hidden'>
      EDHREC: EDH Recommendations and strategy content for Magic: the Gathering Commander.
    </h1>
    <div className={styles.content}>
      <Splash
        align='outsideLeft'
        aspectRatio='1/2'
        backgroundImages={[CARDART.KAALIA]}
        breakpoint='xxl'
        isAboveFold
        isFiltered
        isMasked
        objectPosition='65% center'
      />
      <Splash
        align='outsideRight'
        aspectRatio='1/2'
        backgroundImages={[CARDART.THE_UR_DRAGON]}
        breakpoint='xxl'
        isAboveFold
        isFiltered
        isFlippedX
        isMasked
        objectPosition='25% center'
      />
      <div className={styles.adLeaderboard}>
        <AdLeaderboard margin='none' />
      </div>
      <div className={styles.callout}>
        <HomeTopCallout />
      </div>
      <div className={styles.articles}>
        <HomeTopArticles />
      </div>
      <div className={styles.sidebar}>
        <HomeTopSidebar />
      </div>
      <div className={styles.adMidBanner}>
        <AdMidBanner padding='none' />
      </div>
    </div>
  </section>
)
